<!--
 * @Author: your name
 * @Date: 2020-02-27 10:46:42
 * @LastEditTime: 2020-06-11 10:04:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\components\grow\evaluate.vue
 -->
<template>
  <div class="evaluate">
    <van-list class="list_wrap" v-model="acticeRecordLoading" :finished="acticeRecordFinished" :finished-text="acticeRecordfinishText" :error.sync="acticeRecordError" @load="getGrowRecord()" error-text="请求失败，点击重新加载">
      <div class="evaList" v-for="(item,index) in babyPropInfo" :key="index">
        <div v-if="babyPropInfo.length!=0">
          <div class="title">{{item.recordDate.slice(0,7)}}<span> ({{item.babyTime}})</span></div>
          <ul class="content">
            <li class="item" v-if="item.head!=null  && getDaysBetween(babyBir,item.recordDate)<365">
              <span class="num">{{item.head}}<span class="unit">cm</span></span>
              <span class="item_con">头围</span>
              <span class="state" v-if="item.headState=='2'">正常</span>
              <span class="state state2" v-if="item.headState=='3'">偏大</span>
              <span class="state state2" v-if="item.headState=='1'">偏小</span>
            </li>
            <li class="item">
              <span class="num">{{`${item.recordDate>babyBir||item.recordDate==babyBir?(item.height*10)/100:item.height}`}}<span class="unit" v-if="item.recordDate>babyBir||item.recordDate==babyBir">cm</span><span class="unit" v-if="item.recordDate<babyBir">mm</span></span>
              <span class="item_con">身高</span>
              <span class="state" v-if="item.heightState=='2'">正常</span>
              <span class="state state2" v-if="item.heightState=='3'">偏高</span>
              <span class="state state2" v-if="item.heightState=='1'">偏低</span>
            </li>
            <li class="item">
              <span class="num">{{`${item.recordDate>babyBir||item.recordDate==babyBir?(item.weight*100)/100000:item.weight}`}}<span class="unit" v-if="item.recordDate>babyBir||item.recordDate==babyBir">kg</span><span class="unit" v-if="item.recordDate<babyBir">g</span></span>
              <span class="item_con">体重</span>
              <span class="state" v-if="item.weightState=='2'">正常</span>
              <span class="state state2" v-if="item.weightState=='3'">偏重</span>
              <span class="state state2" v-if="item.weightState=='1'">偏轻</span>
            </li>
          </ul>
          <span class="line"></span>
          <div class='proposal' v-if="item.show">
            <div class="proTitle">
              <div class="state">
                <div class="noNormal" v-if="item.heightState!=2 || item.weightState!=2 ||(item.headState != 2&& item.headState !=null)"><img src="../../../assets/images/grow/nonormal.png" alt="" class="noNormalImg"><span>{{`宝宝${item.headState==1 ?'头围偏小' :'' || item.headState==3 ? '头围偏大':'' || item.headState==null?'' :''}${(item.headState !=2 &&item.headState !=null) && (item.heightState !=2 || item.weightState !=2 ) ?'、':''}${item.heightState==1 ?'身高偏低' :'' || item.heightState==3 ? '身高偏高':''}${item.heightState !=2 &&item.weightState !=2 ?'、':''}${item.weightState==1 ?'体重偏轻' :'' || item.weightState==3 ? '体重偏重':''}`}}</span></div>
                <div class="normal" v-if="item.heightState==2 && item.weightState==2 && (item.headState == 2||item.headState == null)"><img src="../../../assets/images/grow/normal.png" alt="" class="normalImg">{{`${item.headState == null ?'宝宝身高、体重发育正常':'宝宝头围、身高、体重发育正常'}`}}</div>
              </div>
              <div class="expand" v-if="(item.heightState !=2 || item.weightState !=2 || (item.headState !=null&&item.headState!=2))">
                <div class="openCon" v-if="!item.state" @click="proposal(index)" :state="false">展开建议
                  <van-icon name="arrow-down" class="down" />
                </div>
                <div class="closeCon" v-if="item.state" @click="proposal(index)">收起建议
                  <van-icon name="arrow-up" class="up" />
                </div>
              </div>
              <div class="expandCon" v-if="item.state">
                <div class="xiaohe"><img src="../../../assets/images/grow/xiaohe.png" alt=""></div>
                <div class="text">{{`${item.headSuggestion==null || item.headSuggestion=='' ? '':'头围'+item.headSuggestion}${item.heightSuggestion==null || item.heightSuggestion=='' ? '':'身高'+item.heightSuggestion}${item.weightSuggestion==null || item.weightSuggestion=='' ? '':'体重'+item.weightSuggestion}`}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="noRecord" v-if="noBabyRecord">
      <img src="../../../assets/images/grow/he.png" alt="">
      <span>暂无记录…</span>
    </div>
  </div>
</template>

<style lang="less" scoped>
.evaluate {
  width: 100%;
  min-height: 100%;
  // background: #f6f6f6;
  padding-top: 40px;
  .evaList {
    background: #fff;
    border-top: 10px solid #f6f6f6;
    padding: 15px;
    .title {
      color: #9a9a9a;
      font-size: 13px;
      font-weight: 600;
    }
    .content {
      margin-top: 38px;
      display: flex;
      flex-direction: row;
      .item {
        width: 33%;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        .num {
          color: #d7c476;
          font-size: 28px;
          font-weight: bold;
          .unit {
            font-size: 10px;
          }
        }
        .item_con {
          color: #9a9a9a;
          font-size: 10px;
          font-weight: 400;
          margin-top: 6px;
        }
        .state {
          margin-top: 6px;
          width: 30px;
          height: 13px;
          background: #eaf7f7;
          color: #3ac2b3;
          font-size: 10px;
          border-radius: 4px;
          padding: 2px 5px;
          line-height: 15px;
        }
        .state2 {
          background: #fdefef;
          color: #f66563;
        }
      }
    }
    .line {
      margin-top: 17px;
      display: block;
      height: 1px;
      background: #dfdfdf;
    }
    .proposal {
      margin-top: 17px;
      .proTitle {
        overflow: hidden;
        .state {
          font-size: 11px;
          color: #333333;
          float: left;
          .normal {
            .normalImg {
              width: 11px;
              height: 11px;
              padding-right: 5px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .noNormal {
            color: #f66563;
            .noNormalImg {
              width: 11px;
              height: 11px;
              padding-right: 5px;
              position: relative;
              top: 1px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .expand {
          float: right;
          color: #999999;
          font-size: 11px;
          font-weight: 400;
          margin-right: 12px;
          .openCon {
            .down {
              width: 10px;
              height: 5px;
              padding-bottom: 2px;
              padding-left: 3px;
              float: right;
              padding-top: 2px;
            }
          }
          .closeCon {
            .up {
              width: 10px;
              height: 5px;
              padding-bottom: 2px;
              padding-left: 3px;
              float: right;
              padding-top: 2px;
            }
          }
        }
      }
      .expandCon {
        margin-top: 30px;
        background: #f6f6f6;
        border-radius: 16px;
        position: relative;
        overflow: hidden;
        height: 104px;
        .xiaohe {
          width: 50px;
          height: 80px;
          display: inline-block;
          margin: 13px 0 13px 14px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .text {
          // width: 266px;
          position: absolute;
          top: 23px;
          left: 77px;
          font-size: 11px;
          line-height: 21px;
          color: #d7c476;
          height: 65px;
          overflow: auto;
          white-space: pre-wrap;
          padding-right: 12px;
        }
      }
    }
  }
  .noRecord {
    height: 100%;
    img {
      width: 174px;
      height: 174px;
      display: block;
      margin: 0 auto;
      padding-top: 20px;
    }
    span {
      text-align: center;
      padding-top: 18px;
      font-size: 14px;
      color: #333;
      display: block;
    }
  }
  /deep/.van-list__loading {
    background: #fff;
  }
  /deep/.van-list__finished-text {
    background: #fff;
    margin-bottom: 80px;
    border-top: 10px solid #f6f6f6;
  }
}
</style>


<script>
import API from "@/utils/axiosApi/growApi.js";
import { setTimeout } from 'timers';
import { constants } from 'fs';
export default {
  name: "",
  data () {
    return {
      flag: false,
      userInfo: '',
      ArticleCollectParams: {
        page: 1, size: 10
      },
      babyPropInfo: [],
      noBabyRecord: false,
      acticeRecordLoading: false, // 是否加载状态
      acticeRecordFinished: false, // 是否加载完成
      acticeRecordError: false, // 是否加载失败
      acticeRecordfinishText: '', // 加载完成文本
      // expandConShow:false,
      proposalId: '',
      babyNum: this.$route.query.num, // 宝宝胎次
      babySex: '',
      babyInfo: [],
      babyBir: '',
      isVisble: true,
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {

    })
  },
  props: {
    babyHeadShow: {
      default: false,
      type: Boolean
    },
  },
  mounted () {
    this.getBabyInfo()
  },
  methods: {
    // 算出今天和宝宝生日相差的天数
    getDaysBetween: function (dateString1, dateString2) {
      var startDate = Date.parse(dateString1);
      var endDate = Date.parse(dateString2);
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      return days;
    },
    proposal: function (ind) {
      this.babyPropInfo[ind].state = !this.babyPropInfo[ind].state;
      this.$forceUpdate()
    },
    getBabyInfo: function () {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
      API.getBabyInfo({ crmId: this.userInfo.crm_id }, res => {
        if (res.code == "200") {
          this.babyInfo = res.data
          for (var i = 0; i < this.babyInfo.length; i++) {
            if (this.babyNum == this.babyInfo[i].num) {
              this.babySex = this.babyInfo[i].sex
              this.babyBir = this.babyInfo[i].birth
              if (this.babySex != 'M' && this.babySex != 'F') {
                this.babySex = 'M'
              }
            }
          }
          this.getGrowRecord()
        }
      })
    },
    // 获取成长记录
    getGrowRecord: function () {
      if (this.babySex != '') {
        API.getGrowInfo({}, { "data": { crmId: this.userInfo.crm_id, childNumber: this.babyNum, birthday: this.babyBir, sex: this.babySex }, "page": this.ArticleCollectParams.page, "size": this.ArticleCollectParams.size }, res => {
          this.acticeRecordLoading = false;
          if (res.code == "200") {
            this.babyPropInfo = this.babyPropInfo.concat(res.data.content)
            let list = ['孕0周', '孕2周', '孕3周', '孕4周', '孕5周', '孕6周', '孕7周', '孕8周', '孕9周', '孕10周', '孕11周']
            for (let i = 0; i < this.babyPropInfo.length; i++) {
              this.babyPropInfo[i].state = false;
              this.babyPropInfo[i].show = true;
              var time = this.babyPropInfo[i].babyTime
              for (let j = 0; j < list.length; j++) {
                if (time == list[j]) {
                  this.babyPropInfo[i].show = false
                }
              }
            }
            if (this.ArticleCollectParams.page >= Math.ceil(res.data.totalElements / this.ArticleCollectParams.size)) {
              this.acticeRecordFinished = true;
            } else {
              this.ArticleCollectParams.page += 1;
              this.acticeRecordfinishText = "——已经到底了哦——";
            }
            if (this.ArticleCollectParams.page == 1 && res.data.content.length == 0) {
              this.acticeRecordfinishText = "";
              this.noBabyRecord = true
            }
          } else {
            this.acticeRecordLoading = false;
            this.acticeRecordError = true
          }
        }, res => {
          this.acticeRecordLoading = false;
          this.acticeRecordError = true;
        })
      }
    }
  },

}
</script>
